import React from 'react';
import { IconUIComponentProps, useIconStyle } from './Icon';

export default function DownloadIcon({
  size,
  color,
  style,
  noFill,
  className,
}: IconUIComponentProps) {
  const styles = useIconStyle({ noFill });
  return (
    <svg
      className={[styles.icon, className].join(' ')}
      fontSize={size}
      color={color}
      style={style}
      viewBox='0 0 24 15'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.47045 5.50408C5.96431 3.35331 7.42543 1.54457 9.43792 0.62996C12.8863 -0.938434 16.9245 0.522685 18.6177 3.89256C21.6017 3.9588 24 6.41936 24 9.4456C24 12.5135 21.5352 15 18.4942 15L4.61957 14.9998C4.23455 14.9897 3.85178 14.9326 3.47645 14.8295C0.955481 14.1268 -0.5237 11.4967 0.171753 8.95316C0.819816 6.58675 3.12276 5.12972 5.47045 5.50408ZM4.63257 13.9912H18.4942C20.9829 13.9912 23 11.9563 23 9.4456C23 6.93486 20.9829 4.89999 18.4942 4.89999H18.3022C18.1056 4.89999 17.9273 4.78378 17.8464 4.60302C16.473 1.53185 12.8931 0.165049 9.84878 1.54967C7.98329 2.39748 6.66997 4.14067 6.35871 6.18217C6.31321 6.48055 6.01983 6.67207 5.73139 6.59167C3.7429 6.03746 1.68514 7.2152 1.13567 9.2216C0.587081 11.228 1.75394 13.3028 3.74103 13.8566C4.03763 13.9381 4.34089 13.9834 4.63257 13.9912Z'
      />
      <path d='M13 11.1776L17.1251 6.5022C17.3078 6.29513 17.6237 6.27537 17.8308 6.45807C18.0379 6.64077 18.0576 6.95673 17.8749 7.1638L12.8749 12.8308C12.6799 13.0519 12.3368 13.0571 12.1352 12.8419L7.13521 7.50795C6.94636 7.30648 6.95659 6.99006 7.15805 6.80121C7.35952 6.61236 7.67594 6.62258 7.86479 6.82405L12 11.2355L12 0.5C12.5 0.5 12.5 0.5 12.5 0.5L13 0.5L13 11.1776Z' />
    </svg>
  );
}
